import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {PaymentRequestOnlineAttemptModel} from "../paymentRequestOnlineAttempt.model";
import {Injectable} from "@angular/core";
import {PaymentRequestOnlineAttemptSummaryConverter} from "./paymentRequestOnlineAttemptSummary.converter";import {
    AccountingAccountConverter
} from "../../../../../../../accounting/account/api/entity/converter/accountingAccount.converter";
import {ExternalIdConverter} from "../../../../../../../common/externalId/api/entity/converter/externalId.converter";
@Injectable({
    providedIn: 'root'
})
export class PaymentRequestOnlineAttemptConverter extends HttpModelConverter<PaymentRequestOnlineAttemptModel> {

    constructor(private summaryConverter: PaymentRequestOnlineAttemptSummaryConverter,
                private externalIdConverter: ExternalIdConverter,
                private accountingAccountConverter: AccountingAccountConverter) {
        super();
    }

    protected createInstance(): PaymentRequestOnlineAttemptModel {
        return new PaymentRequestOnlineAttemptModel();
    }

    protected enrichObject(result: PaymentRequestOnlineAttemptModel, src: PaymentRequestOnlineAttemptModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.externalId = this.externalIdConverter.convert(src.externalId);
        result.targetAccountingAccount = this.accountingAccountConverter.convert(src.targetAccountingAccount);
    }
}
